import { Set, Get } from "../../../../../Request";
export const SubmitForm = async data => {
  await Set({
    url: "/off/store",
    data: data,
  });
};
export const GetData = async (page = 1 , limit=15 , filter) => {
  return await Get({
    url: "/off/list",
    data: { ...filter,limit },
    page,
  }).then(data => {
    return data;
  });
};
export const SearchData = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/off/list",
    data: {
      limit: limit,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
export const DeletData = async data => {
  return await Set({
    url: "/off/destroy",
    data: data,
  });
};
